<ng-container *transloco="let t">
    <div class="modal-header">
        {{ t('IDS_ERROR') }}
    </div>
    <div class="modal-body">
        {{ message }}
    </div>
    <div class="modal-footer justify-content-end">
        <button type="button" class="btn btn-primary" (click)="activeModal.close()">
            {{ t('IDS_BUTTON_CONTINUE') }}
        </button>
    </div>
</ng-container>
